module.exports = __webpack_public_path__ + "img/web-search.9e978c59.svg";